import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInputLogin from "../../../../../Components/CustomInputLogin/CustomInputLogin";
import CustomDropdownMui from "../../../../../Components/CustomDropDown/CustomDropdown";
import user_icon_image from "../../../../../Assets/User_icon_image.svg";
import email_input_icon from "../../../../../Assets/email_input_icon.svg";

import country_icon from "../../../../../Assets/country_icon.svg";

import phone_input_icon from "../../../../../Assets/phone_input_icon.svg";

import location_icon from "../../../../../Assets/location_icon.svg";

import call_icon from "../../../../../Assets/call_icon.svg";

import mail_icon from "../../../../../Assets/mail_icon.svg";

// import actions from "../../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import CustomMap from "../../../../../Components/CustomMap/CustomMap";
import "./ContactUsSection.css";
import { BiDownArrow } from "react-icons/bi";
import { LuArrowDownWideNarrow } from "react-icons/lu";
import actions from "../../../../../ReduxStore/actions";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const countries = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "UK", label: "UK" },
  { value: "Australia", label: "Australia" },
];

// Validation schema using Yup
const validationSchema = Yup.object({
  full_name: Yup.string().required("Full Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phone_number: Yup.string()
    .matches(/^[0-9]+$/, "Must be a number")
    .min(10, "Must be at least 10 digits")
    .required("Phone Number is required"),
  message: Yup.string().required("Message is required"),
  country: Yup.string().required("Countries is required"),
});

const ContactUsection = ({ getInTouchDates, values ,onClose,sectionNameForApproveAndReject}) => {
  const { postContactUsForm } = useSelector(
    (state) => state?.postContactUsForm
  );

  console.log(postContactUsForm);

  const dispatch = useDispatch();
  const initialValues = {
    full_name: "",
    email: "",
    country: "",
    phone_number: "",
    message: "",
  };

  // const handleSubmit = (values, { resetForm }) => {
  //     console.log("Form Values of contact form:", values);

  //     const data1 = { data: values, method: "post", apiName: "postContactUsForm" };

  //     dispatch(actions.POSTCONTACTUSFORM(data1));

  //     resetForm();

  // };


  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")


  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getContactUsSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETCONTACTUSSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "Contact Us section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);

  return (
    <Grid sx={{ background: "white" }}>
      <Box
        sx={{ maxWidth: { xs: "100%", md: "70%" }, margin: "0 auto", pt: 4 }}
      >
        <Typography
          variant="h3"
          textAlign="center"
          gutterBottom
          // fontSize="30px"
          sx={{ mb: 2 }}
        >
          <span style={{ fontWeight: "800" }}>
            {responseData?.heading || values?.title || "Default Heading"}
          </span>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            paddingBottom: 4,
            maxWidth: "800px",
            margin: "0 10px",
            textAlign: "center",
            color: "#b0aaaa",
          }}
        >
          {responseData?.content || values?.content || "Default Content"}
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        sx={{ maxWidth: "90%", margin: { xs: "0", md: "0 auto" }, pb: "30px" }}
      >
        {/* Left Section */}
        <Grid item xs={12} md={7}>
          <Typography variant="h6" gutterBottom>
            Contact
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <img
              src={location_icon}
              alt="Location Icon"
              style={{ marginRight: "8px" }}
            />
            <Typography
              variant="body1"
              sx={{ maxWidth: "250px", color: "#3B4056" }}
            >
              {responseData?.additional_data?.contact?.address ||
                values?.address ||
                "Default Content"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <img
              src={mail_icon}
              alt="Call Icon"
              style={{ marginRight: "8px" }}
            />
            <Typography
              variant="body1"
              sx={{ maxWidth: "200px", color: "#3B4056" }}
            >
              {(responseData?.additional_data?.contact?.country_code &&
                responseData?.additional_data?.contact?.mobile_no) ?
                `${responseData.additional_data.contact.country_code} ${responseData.additional_data.contact.mobile_no}` :
                `${values?.country_code ?? ''} ${values?.mobile_no ?? ''}`}


            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={call_icon}
              alt="Mail Icon"
              style={{ marginRight: "8px" }}
            />
            <Typography
              variant="body1"
              sx={{ maxWidth: "300px", color: "#3B4056" }}
            >
              {responseData?.additional_data?.contact?.email ||
                values?.email ||
                "Default Content"}
            </Typography>
          </Box>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={5}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
          // onSubmit={handleSubmit}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Grid xs={12}>
                    {/* <CustomInputLogin
                                            name="full_name"
                                            custPlaceholder="Full Name"
                                            inputType="text"
                                            image={user_icon_image}

                                        /> */}
                    <Box
                      className="input-box"
                    // sx={{border:"1px solid black",p:0.8,borderRadius:'3px'}}
                    >
                      <Typography
                        variant="body1"
                        className="input-typography"
                      // sx={{display:"flex",alignItems:"center"}}
                      >
                        <sapn className="input-imgspan">
                          <img src={user_icon_image}></img>
                        </sapn>
                        Full Name
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      className="input-box"
                    // sx={{border:"1px solid black",p:0.8,borderRadius:'3px'}}
                    >
                      <Typography
                        variant="body1"
                        className="input-typography"
                      // sx={{display:"flex",alignItems:"center"}}
                      >
                        <sapn className="input-imgspan">
                          <img src={email_input_icon}></img>
                        </sapn>
                        Email
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <Box
                        className="input-box"
                      // sx={{border:"1px solid black",p:0.8,borderRadius:'3px'}}
                      >
                        <Typography
                          variant="body1"
                          className="input-typography"
                        // sx={{display:"flex",alignItems:"center"}}
                        >
                          <sapn className="input-imgspan">
                            <img src={country_icon}></img>
                          </sapn>
                          Country
                        </Typography>
                        <sapn className="input-imgspan">
                          <LuArrowDownWideNarrow color="gray" />
                        </sapn>
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box
                        className="input-box"
                      // sx={{border:"1px solid black",p:0.8,borderRadius:'3px'}}
                      >
                        <Typography
                          variant="body1"
                          className="input-typography"
                        // sx={{display:"flex",alignItems:"center"}}
                        >
                          <sapn className="input-imgspan">
                            <img src={phone_input_icon}></img>
                          </sapn>
                          Phone Number
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        className="textarea-box"
                      // sx={{border:"1px solid black",p:0.8,borderRadius:'3px'}}
                      >
                        <Typography
                          variant="body1"
                          className="textarea-typography"
                        // sx={{display:"flex",alignItems:"center"}}
                        >

                          Message
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>



                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 60px" },
                        boxShadow: "none",

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "#C38F51 0% 0% no-repeat padding-box",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>

      <CustomMap mapLink={values?.location_link || responseData?.additional_data?.contact?.location_link} />
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />

    </Grid>

  );
};

export default ContactUsection;
